<template>
<div class="comments_list no-trans" v-loading="loading">
   <div class="comments_list_box">
        <div class="top_box">
            <img src="@/assets/img/login/Frame.png" alt="">
            <span class="span1" @click="handle_home">首页</span>
            > 裁判点评
        </div>
        <div class="check_box">
            <div class="check_felx">
                <div class="check_title">纠纷发生地</div>
                <div class="check_list" :class="{'check_list_minh':jffsd_show,'check_list_maxh':!jffsd_show}">
                    <div class="check_item" :class="{check_item_ac:item.id==jffsd_ac.id}" v-for="(item,index) in jffsd_list" :key="index" @click="handle_jffsd_ac(item)">{{ item.name }}</div>
                </div>
                <div class="check_show" :class="{'check_show2':jffsd_show}" @click="handle_jffsd_show">
                    <img src="@/assets/img/index/legal/check_show.png" alt="">
                </div>
            </div>
            <div class="check_felx">
                <div class="check_title">委托人住所地</div>
                <div class="check_list" :class="{'check_list_minh':wtrszd_show,'check_list_maxh':!wtrszd_show}">
                    <div class="check_item" :class="{check_item_ac:item.id==wtrszd_ac.id}" v-for="(item,index) in wtrszd_list" :key="index" @click="handle_wtrszd_ac(item)">{{ item.name }}</div>
                </div>
                <div class="check_show" :class="{'check_show2':wtrszd_show}" @click="handle_wtrszd_show">
                    <img src="@/assets/img/index/legal/check_show.png" alt="">
                </div>
            </div>
            <div class="check_felx">
                <div class="check_title">一级分类</div>
                <div class="check_list" :class="{'check_list_minh':yjfl_show,'check_list_maxh':!yjfl_show}">
                    <div class="check_item" :class="{check_item_ac:item.id==yjfl_ac.id}" v-for="(item,index) in yjfl_list" :key="index" @click="handle_yjfl_ac(item)">{{ item.title }}</div>
                </div>
                <div class="check_show" :class="{'check_show2':yjfl_show}" @click="handle_yjfl_show">
                    <img src="@/assets/img/index/legal/check_show.png" alt="">
                </div>
            </div>
            <div class="check_felx" v-if="yjfl_ac.id">
                <div class="check_title">二级分类</div>
                <div class="check_list" :class="{'check_list_minh':ejfl_show,'check_list_maxh':!ejfl_show}">
                    <div class="check_item" :class="{check_item_ac:item.id==ejfl_ac.id}" v-for="(item,index) in ejfl_list" :key="index"  @click="handle_ejfl_ac(item)">{{ item.title  }}</div>
                </div>
                <div class="check_show" :class="{'check_show2':ejfl_show}" @click="handle_ejfl_show">
                    <img src="@/assets/img/index/legal/check_show.png" alt="">
                </div>
            </div>
            <div class="check_felx" v-if="ejfl_ac.id">
                <div class="check_title">三级分类</div>
                <div class="check_list" :class="{'check_list_minh':sjfl_show,'check_list_maxh':!sjfl_show}">
                    <div class="check_item" :class="{check_item_ac:item.id==sjfl_ac.id}" v-for="(item,index) in sjfl_list" :key="index" @click="handle_sjfl_ac(item)">{{ item.title  }}</div>
                </div>
                <div class="check_show" :class="{'check_show2':sjfl_show}" @click="handle_sjfl_show">
                    <img src="@/assets/img/index/legal/check_show.png" alt="">
                </div>
            </div>
            <div class="check_felx">
                <div class="check_title">关键字</div>
                <div class="check_keyword">
                    <input type="text" v-model="keyword" placeholder="请输入关键字" @keyup.enter="handle_keyword">
                    <div class="btns" @click="handle_keyword">搜索</div>
                </div>
            </div>

            <div class="check_felx" v-if="!mobile_view || jffsd_ac.id || wtrszd_ac.id || yjfl_ac.id || ejfl_ac.id || sjfl_ac.id">
                <div class="check_title">已选择</div>
                <div class="check_ac_flex">
                    <div class="check_ac_box" v-if="jffsd_ac.id">
                        {{ jffsd_ac.name }}
                        <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('jffsd_ac')">
                    </div>
                    <div class="check_ac_box" v-if="wtrszd_ac.id">
                        {{ wtrszd_ac.name }}
                        <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('wtrszd_ac')">
                    </div>
                    <div class="check_ac_box" v-if="yjfl_ac.id">
                        {{ yjfl_ac.title }}
                        <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('yjfl_ac')">
                    </div>
                    <div class="check_ac_box" v-if="ejfl_ac.id">
                        {{ ejfl_ac.title }}
                        <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('ejfl_ac')">
                    </div>
                    <div class="check_ac_box" v-if="sjfl_ac.id">
                        {{ sjfl_ac.title }}
                        <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('sjfl_ac')">
                    </div>
                    <!-- <div class="check_ac_text"></div> -->
                    <div class="chack_ac_clear" @click="handle_qk">清空</div>
                </div>
            </div>
        </div>
        <div class="list_box">
            <div class="list_item">
                <div class="item" v-for="(item,index) in list" :key="index" >
                    <div class="title_flex">
                        <div class="titles" @click="handle_xdp(item)" :role="mobile_view ? 'link' : null"
                            :tabindex="mobile_view ? 0 : null" @keydown.enter.prevent="handle_xdp(item)">
                            {{ item.title }}
                        </div>
                        <div class="teges">
                            <img src="@/assets/img/index/comments_case/grade_c.png" alt="" v-if="item.grade==1">
                            <img src="@/assets/img/index/comments_case/grade_z.png" alt="" v-if="item.grade==2">
                            <img src="@/assets/img/index/comments_case/grade_g.png" alt="" v-if="item.grade==3">
                            <img src="@/assets/img/index/comments_case/grade_t.png" alt="" v-if="item.grade==4">
                        </div>
                    </div>
                    <div class="jianjie">
                        {{ item.trial_obj }}
                        <span  @click="handle_xdp(item)">阅读全文</span>
                    </div>
                    <div class="btns_flex">
                        <div class="btns_left">
                            <div class="btns1">
                                <img src="@/assets/img/index/comments_case/zan.png" alt="">
                                &nbsp;
                                赞同
                                &nbsp;
                                {{ item.good_num }}
                            </div>
                            <div class="btns2">
                                <img src="@/assets/img/index/comments_case/cai.png" alt="">
                            </div>
                            <div class="btns3">
                                <img src="@/assets/img/index/comments_case/pl_num.png" alt="">
                                {{item.comment_num}}条评论
                            </div>
                        </div>
                        <div class="btns_right">
                            <div class="btns1" @click="handle_xdp(item)" v-if="item.is_comment==1">
                                <img src="@/assets/img/index/comments_case/pl.png" alt="" class="img1">
                                <img src="@/assets/img/index/comments_case/pl2.png" alt="" class="img2">
                                写点评
                            </div>
                        </div>

                    </div>
                </div>
                <div v-if="mobile_view && !loading && !list.length" class="list_empty">暂无符合条件的裁判点评</div>
                <div class="pages_box" v-if="!mobile_view || total > pages.limit">
                    <div class="btns" @click="handle_pages(1)">首页</div>
                    <site-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        background
                        :page-size="pages.limit"
                        layout="prev, pager, next"
                        :total="total">
                    </site-pagination>
                    <div class="btns"  @click="handle_pages(last_page || 1)">尾页</div>
                </div>
            </div>
            <div class="list_nuw">
                <comments_list_right ref="comments_list_right"></comments_list_right>
            </div>

        </div>
   </div>  
</div>
</template>
<script>
import {
    mapState
} from 'vuex'

import comments_list_right from '@/components/comments/comments_list_right.vue'//右边


export default {
    components: {
        comments_list_right
    },
    name: "homes",
    data() {
        return {
            loading:false,
            jffsd_list:'',//纠纷发生地列表
            jffsd_ac:{},//纠纷发生地选中
            jffsd_show:'',//纠纷发生地的显示隐藏
            
            wtrszd_list:'',//委托人住所地列表
            wtrszd_ac:{},//委托人住所地选中
            wtrszd_show:'',//委托人住所地的显示隐藏

            yjfl_list:'',//一级分类列表
            yjfl_ac:{},//一级分类选中
            yjfl_show:'',//一级分类的显示隐藏

            ejfl_list:'',//二级分类列表
            ejfl_ac:{},//二级分类选中
            ejfl_show:'',//二级分类的显示隐藏
            
            sjfl_list:'',//三级分类列表
            sjfl_ac:{},//三级分类选中
            sjfl_show:'',//三级分类的显示隐藏
            list:[],
            total:0,
            last_page:0,
            keyword:'',//关键字
            pages:{
                page:1,
                limit:10,
            },
            banner_ac:0,
            banner_list:[1,2,3]
          
        }
    },
    computed: {
       
    },
    watch: {
        
    },
    created() {
        this.get_list()
        this.get_area()
        this.get_cause_list()
    },
    methods: {
        get_area(){
            this.loading=true
            this.$api("getChinaArea", {
                parent_id:1,
				type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('地址',res)
                if (res.code == 1) {
                    this.jffsd_list=res.data
                    this.wtrszd_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        //获取分类
        get_cause_list(){
            this.loading=true
            this.$api("cause", {
				
			}, "get").then((res) => {
                this.loading = false
                console.log('案由',res)
                if (res.code == 1) {
                    this.yjfl_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handleSizeChange(e){
            console.log('条数',e)
        },
        handleCurrentChange(e){
            console.log(' 页数',e)
            this.pages.page=e
            this.get_list()
        },
        handle_pages(i){
            console.log('首页尾页',i)
            this.pages.page=i
            this.get_list()

        },
        handle_home(){
            this.$router.push({
                path:'/home',
            })
        },
        handle_jffsd_show(){
            this.jffsd_show=!this.jffsd_show
        },
        handle_wtrszd_show(){
            this.wtrszd_show=!this.wtrszd_show
        },
        handle_yjfl_show(){
            this.yjfl_show=!this.yjfl_show
        },
        handle_ejfl_show(){
            this.ejfl_show=!this.ejfl_show
        },
        handle_sjfl_show(){
            this.sjfl_show=!this.sjfl_show
        },
        change_banner(e){
            // console.log('却换触发',e)
            this.banner_ac=e
        },
        handle_jffsd_ac(item){
            this.jffsd_ac=item
            this.pages.page=1
            this.get_list()
        },
        handle_wtrszd_ac(item){
            this.wtrszd_ac=item
            this.pages.page=1
            this.get_list()
        },
        handle_yjfl_ac(item){
            this.yjfl_ac=item
            this.ejfl_list=item.child
            this.ejfl_ac={}
            this.sjfl_list=[]
            this.sjfl_ac={}
            this.pages.page=1
            this.get_list()
        },
        handle_ejfl_ac(item){
            this.ejfl_ac=item
            this.sjfl_list=item.child
            this.sjfl_ac={}
            this.pages.page=1
            this.get_list()
            
        },
        handle_sjfl_ac(item){
            this.sjfl_ac=item
            this.pages.page=1
            this.get_list()
        },
        ac_clear(text){
            this[text]={}
            if(text=='yjfl_ac'){
                this.ejfl_list=[]
                this.ejfl_ac={}
                this.sjfl_list=[]
                this.sjfl_ac={}
            }
            if(text=='ejfl_ac'){
                this.sjfl_list=[]
                this.sjfl_ac={}
            }
            this.pages.page=1
            this.get_list()
 
        },
        handle_qk(){
            this.jffsd_ac={}
            this.wtrszd_ac={}
            this.yjfl_ac={}
            this.ejfl_ac={}
            this.ejfl_list=[]
            this.sjfl_ac={}
            this.sjfl_list=[]
            this.pages.page=1
            this.get_list()
        },
        handle_clear(){
            this.jffsd_ac={}
            this.wtrszd_ac={}
            this.yjfl_ac={}
            this.ejfl_ac={}
            this.sjfl_ac={}
            this.ejfl_list=[]
            this.sjfl_list=[]
            this.pages.page=1
            this.get_list()
        },
        handle_keyword(){
            this.pages.page=1
            this.get_list()
        },
        get_list(){
            this.loading = true
            this.$api("caseList", {
                ...this.pages,
                anliku:0,//是否为案例库
                happen_province:this.jffsd_ac.name||'',//发生地所在省
                province:this.wtrszd_ac.name||'',//委托人所在省
                cateid:this.yjfl_ac.id||'',//一级分类
                cateid2:this.ejfl_ac.id||'',//二级费雷
                cateid3:this.sjfl_ac.id||'',//三级分类
                keyword:this.keyword||'',//关键字
                
			}, "get").then((res) => {
                this.loading = false
                console.log('案例库',res)
                if (res.code == 1) {
                   this.list=res.data.data
                   this.last_page=res.data.last_page
                   this.total=res.data.total
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_xdp(item){
            this.$router.push({
                path:'/comments_detial',
                query:{
                    id:item.id
                }
            })
        },
    },

}
</script>
<style scoped lang="less">
.comments_list{
    padding-bottom: 100px;
    background-color: #F5F5F5;
    .comments_list_box{
        width: 1440px;
        margin: auto;
        .top_box{
            display: flex;
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            padding: 20px 0;

            .span1 {
                cursor: pointer;
            }

            img {
                width: 14px;
                height: 14px;
                margin-right: 10px;
            }
        }
        .check_box{
            width: 1440px;
            // height: 261px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            padding:0 32px;
            .check_felx{
                display: flex;
                // align-items: center;
                padding: 24px 0px 14px 0;
                border-bottom: 1px solid #EEEEEE ;
                .check_title{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #999999;
                    width: 90px;
                    flex-shrink: 0;
                }
                .check_list{
                    display: flex;
                    flex-wrap: wrap;
                    width: 1260px;
                    .check_item{
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        margin-right: 40px;
                        margin-bottom: 10px;
                        &:hover{
                            color: #377CFD;
                        }
                    }
                    .check_item_ac{
                        color: #377CFD;
                    }
                }
                .check_list_maxh{
                    height: 60px;
                    overflow: hidden;
                }
                .check_list_minh{
                    min-height: 60px;
                }
                .check_show{
                    width: 20px;
                    height: 20px;
                    flex-shrink: 0;
                    img{
                        width: 20px;
                        height: 20px;
                        cursor: pointer;
                    }
                }
                .check_show2{
                    img{
                        transform: rotate(-180deg);
                    }
                }
                .check_ac_flex{
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                    .check_ac_box{
                        // width: 102px;
                        padding: 0 10px;
                        height: 29px;
                        background: #F8F8F8;
                        border-radius: 0px 0px 0px 0px;
                        margin-right: 11px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        
                        font-weight: 400;
                        font-size: 14px;
                        color: #656565;
                        img{
                            width: 12px;
                            height: 12px;
                            margin-left: 14px;
                            cursor: pointer;
                        }

                    }
                    .chack_ac_clear{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        cursor: pointer;
                    }
                }

                .check_keyword{
                    display: flex;
                    align-items: center;
                    input{
                        width: 200px;
                        height: 32px;
                        border: 1px solid #377CFD;
                        border-radius: 5px;
                        padding: 10px;
                        margin-right: 20px;
                        font-size: 15px;
                    }
                    .btns{
                        width: 92px;
                        height: 32px;
                        background: #FFFFFF;
                        border-radius: 4px 4px 4px 4px;
                        border: 1px solid #377CFD;
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #377CFD;
                        text-align: center;
                        line-height: 32px;
                    }
                }
            }
        }
        .list_box{
            margin-top:20px ;
            display: flex;
            justify-content: space-between;
            .list_item{
                width: 1000px;
                padding: 40px;
                background-color: #FFFFFF;
                .item{
                    padding-bottom: 13px;
                    border-bottom: 1px solid #D9D9D9;
                    margin-bottom: 32px;
                    .title_flex{
                        display: flex;
                        align-items: center;
                        padding-bottom: 24px;
                        .titles{
                            max-width: 600px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 24px;
                            color: #333333;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: vertical;
                        }
                        .teges{
                            display: flex;
                            align-items: center;
                            margin-left: 23px;
                            img{
                                width: 70px;
                                height: 25px;
                            }
                        }
                    }
                    .jianjie{
                        
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        span{
                            color: #377CFD;
                            cursor: pointer;
                        }
                    }
                    .btns_flex{
                        display: flex;
                        justify-content: space-between;
                        padding-top: 24px;
                        .btns_left{
                            display: flex;
                            align-items: center;
                            padding-bottom: 19px;
                            .btns1{
                                // width: 124px;
                                padding: 0 21px;
                                height: 36px;
                                background: #377CFD;
                                background:rgba(55, 124, 253, 0.08);
                                border-radius: 4px 4px 4px 4px;
                                // opacity: 0.08;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                cursor: pointer;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 14px;
                                color: #377CFD;
                                img{
                                    width:14px ;
                                    height: 14px;
                                }

                            }
                            .btns2{
                                width: 36px;
                                height: 36px;
                                background:rgba(55, 124, 253, 0.08);
                                border-radius: 4px 4px 4px 4px;
                                margin-left: 8px;
                                cursor: pointer;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                img{
                                    width:14px ;
                                    height: 14px;
                                }
                            }
                            .btns3{
                                margin-left: 24px;
                                display: flex;
                                align-items: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;


                                img{
                                    // width:13px ;
                                    height: 11px;
                                    margin-right:8px ;
                                }
                            }
                        }
                        .btns_right{
                            .btns1{
                                width: 134px;
                                height: 36px;
                                background: #FFFFFF;
                                border-radius: 4px 4px 4px 4px;
                                border: 1px solid #BABABA;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                cursor: pointer;
                                img{
                                    width:14px ;
                                    height: 14px;
                                    margin-right: 3px;
                                }
                                .img1{
                                    display: none;
                                }
                                &:hover{
                                    border: 1px solid #377CFD;
                                    background: #377CFD;
                                    color: #FFFFFF;
                                    .img1{
                                        display: block;
                                    }
                                    .img2{
                                        display: none;

                                    }
                                }
                            }
                        }
                    }
                }

                .pages_box{
                    width: 100%;
                    height: 100px;
                    // background-color: red;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    /deep/.el-pagination{
                        .el-pager{
                            .number {
                                background-color: #FFFFFF;
                                border: 1px solid #EEEEEE;
                            }
                            .active{
                                background-color: #377CFD;
                            }
                        }
                    }
                    .btns{
                        width: 40px;
                        height: 32px;
                        background: #FFFFFF;
                        border-radius: 4px 4px 4px 4px;
                        border: 1px solid #EEEEEE;  
                        font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                        font-weight: normal;
                        font-size: 14px;
                        color: #7A7A7A;
                        text-align: center;
                        line-height: 32px;
                        cursor: pointer;
                    }
                }
            }
            .rights_box{
                width: 420px;
                min-height: 100px;
                // background-color: red;
                .r_top{
                    width: 420px;
                    height: 300px;
                    position: relative;
                    padding: 32px 36px;
                    // background-image: url("@/assets/img/index/legal/r_top_bg.png" );
                    background-image: url('../../../assets/img/index/legal/r_top_bg.png');
                    background-size: 100%;
                    // .imgs{
                    //     width: 420px;
                    //     height: 300px;
                    //     position: absolute;
                    //     left: 0;
                    //     top: 0;
                    // }
                    .titles{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 24px;
                        color: #333333;

                    }
                    .text1{
                        padding-top: 14px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;

                    }
                    .nums{
                        padding-top: 20px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 36px;
                        color: #377CFD;

                    }
                    .text2{
                      
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;

                    }
                    .btns_box{
                        padding-top: 40px;
                        .btns{
                            width: 180px;
                            height: 40px;
                            background: #377CFD;
                            box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                            border-radius: 4px 4px 4px 4px;
                            text-align: center;
                            line-height: 40px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #FFFFFF;
                        }
                    }
                }
                .r_bom{
                    width: 420px;
                    height: 460px;
                    // background: red;
                    margin-top: 24px;
                    position: relative;
                    .banner_title{
                        position: absolute;
                        top: 24px;
                        left: 32px;
                        display: flex;
                        align-items: center;
                        z-index: 100;           
                        font-weight: bold;
                        font-size: 18px;
                        color: #FFFFFF;
                    }
                    .change_box{
                        position: absolute;
                        top: 32px;
                        right: 32px;
                        display: flex;
                        align-items: center;
                        z-index: 100;
                        .change_item{
                            width: 6px;
                            height: 6px;
                            background: #F2F2F5;
                            border-radius: 50%;
                            margin-left: 6px;
                        }
                        .change_item_ac{
                            background: #377CFD;
                        }
                    }
                    /deep/.el-carousel{
                        width: 100%;
                        height: 100%;
                        .el-carousel__container{
                            width: 100%;
                            height: 100%;
                            .banner_box{
                                width: 100%;
                                height: 100%;
                                background-image: url('../../../assets/img/index/legal/banner_bg.png');
                                background-size: 100%;
                                padding-top: 88px;
                                .borders_box{
                                    width: 160px;
                                    height: 160px;
                                    margin: auto;
                                    border-radius: 50%;
                                    // margin-top: 88px; 
                                    // background: #FFFFFF;
                                    // opacity: 0.2;
                                    position: relative;
                                    .borders1{
                                        width: 160px;
                                        height: 160px;
                                        background: #FFFFFF;
                                        opacity: 0.2;
                                        position: absolute;
                                        left: 0;
                                        top: 0;
                                        z-index: 1;
                                        border-radius: 50%;

                                    }
                                    .borders2{
                                        width: 132px;
                                        height: 132px;
                                        background: #C4C4C4;
                                        position: absolute;
                                        left: 50%;
                                        top: 50%;
                                        z-index: 2;
                                        border-radius: 50%;

                                        transform: translate(-50%,-50%);
                                        img{
                                            width: 132px;
                                            height: 132px;
                                            border-radius: 50%;

                                        }
                                    }
                                    .tage_box{
                                        width: 100%;
                                        position: absolute;
                                        z-index: 3;
                                        bottom: -4px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        .tages{
                                            cursor: pointer;
                                            width: 104px;
                                            height: 32px;
                                            background: linear-gradient( 180deg, #FAECC6 0%, #F2CF85 100%);
                                            border-radius: 16px 16px 16px 16px;
                                            border: 1px solid #876052;
                                            font-family: Microsoft YaHei, Microsoft YaHei;
                                            font-weight: 400;
                                            font-size: 14px;
                                            color: #6C3E2D;
                                            text-align: center;
                                            line-height: 32px;
                                        }
                                    }
                                    
                                }
                                .ls_name{
                                    padding-top: 28px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 24px;
                                    color: #FFFFFF;
                                    text-align: center;
                                }
                                .ls_texts{
                                    padding-top: 14px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #FFFFFF;
                                    text-align: center;
                                }   
                                .btns_flex{
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    padding-top: 40px;
                                    .btns{
                                        width: 180px;
                                        height: 40px;
                                        background: #377CFD;
                                        box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                                        border-radius: 4px 4px 4px 4px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        line-height: 40px;
                                        text-align: center;
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: bold;
                                        font-size: 14px;
                                        color: #FFFFFF;
                                        cursor: pointer;
                                        img{
                                            width: 14px;
                                            height: 14px;
                                            margin-right: 10px;
                                        }
                                    }
                                }
                            }
                        }
                        .el-carousel__indicators{
                            //  display: none;
                        }
                    }
                }
            }
        }
    }
    
   
    
}

</style>
<style scoped lang="less">
@import "../../../styles/mobile-patterns.less";

@media (max-width: 1024px) {
    .comments_list.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding-bottom: 16px;
    }
    .comments_list.no-trans .comments_list_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .comments_list.no-trans .comments_list_box .top_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        padding: 16px 0;
    }
    .comments_list.no-trans .comments_list_box .top_box img {
        width: 14px;
        height: 14px;
        margin-right: 10px;
    }
    .comments_list.no-trans .comments_list_box .check_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        border-radius: 0px 0px 0px 0px;
        padding: 0 16px;
    }
    .comments_list.no-trans .comments_list_box .check_box .check_felx {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding: 16px 0px 14px 0;
    }
    .comments_list.no-trans .comments_list_box .check_box .check_felx .check_title {
        font-size: 14px;
        width: 90px;
    }
    .comments_list.no-trans .comments_list_box .check_box .check_felx .check_list {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        max-width: 100%;
        width: 100%;
    }
    .comments_list.no-trans .comments_list_box .check_box .check_felx .check_list .check_item {
        font-size: 14px;
        margin-right: 16px;
        margin-bottom: 10px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .comments_list.no-trans .comments_list_box .check_box .check_felx .check_list_maxh {
        height: 60px;
    }
    .comments_list.no-trans .comments_list_box .check_box .check_felx .check_show {
        width: 20px;
        height: 20px;
    }
    .comments_list.no-trans .comments_list_box .check_box .check_felx .check_show img {
        width: 20px;
        height: 20px;
    }
    .comments_list.no-trans .comments_list_box .check_box .check_felx .check_ac_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 10px;
    }
    .comments_list.no-trans .comments_list_box .check_box .check_felx .check_ac_flex .check_ac_box {
        padding: 0 10px;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        margin-right: 11px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        min-height: 29px;
    }
    .comments_list.no-trans .comments_list_box .check_box .check_felx .check_ac_flex .check_ac_box img {
        width: 12px;
        height: 12px;
        margin-left: 14px;
    }
    .comments_list.no-trans .comments_list_box .check_box .check_felx .check_ac_flex .chack_ac_clear {
        font-size: 14px;
    }
    .comments_list.no-trans .comments_list_box .check_box .check_felx .check_keyword {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .comments_list.no-trans .comments_list_box .check_box .check_felx .check_keyword input {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 32px;
        border-radius: 5px;
        padding: 10px;
        margin-right: 16px;
        font-size: 15px;
    }
    .comments_list.no-trans .comments_list_box .check_box .check_felx .check_keyword .btns {
        width: 92px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .comments_list.no-trans .comments_list_box .list_box {
        margin-top: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .comments_list.no-trans .comments_list_box .list_box .list_item {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        padding: 16px;
    }
    .comments_list.no-trans .comments_list_box .list_box .list_item .item {
        padding-bottom: 13px;
        margin-bottom: 16px;
    }
    .comments_list.no-trans .comments_list_box .list_box .list_item .item .title_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-bottom: 16px;
    }
    .comments_list.no-trans .comments_list_box .list_box .list_item .item .title_flex .titles {
        font-size: 24px;
    }
    .comments_list.no-trans .comments_list_box .list_box .list_item .item .title_flex .teges {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-left: 16px;
    }
    .comments_list.no-trans .comments_list_box .list_box .list_item .item .title_flex .teges img {
        width: 70px;
        height: 25px;
    }
    .comments_list.no-trans .comments_list_box .list_box .list_item .item .jianjie {
        font-size: 14px;
    }
    .comments_list.no-trans .comments_list_box .list_box .list_item .item .btns_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .comments_list.no-trans .comments_list_box .list_box .list_item .item .btns_flex .btns_left {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-bottom: 16px;
    }
    .comments_list.no-trans .comments_list_box .list_box .list_item .item .btns_flex .btns_left .btns1 {
        padding: 0 16px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        min-height: 44px;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .comments_list.no-trans .comments_list_box .list_box .list_item .item .btns_flex .btns_left .btns1 img {
        width: 14px;
        height: 14px;
    }
    .comments_list.no-trans .comments_list_box .list_box .list_item .item .btns_flex .btns_left .btns2 {
        width: 36px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        margin-left: 8px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .comments_list.no-trans .comments_list_box .list_box .list_item .item .btns_flex .btns_left .btns2 img {
        width: 14px;
        height: 14px;
    }
    .comments_list.no-trans .comments_list_box .list_box .list_item .item .btns_flex .btns_left .btns3 {
        margin-left: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .comments_list.no-trans .comments_list_box .list_box .list_item .item .btns_flex .btns_left .btns3 img {
        height: 11px;
        margin-right: 8px;
    }
    .comments_list.no-trans .comments_list_box .list_box .list_item .item .btns_flex .btns_right .btns1 {
        width: 134px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .comments_list.no-trans .comments_list_box .list_box .list_item .item .btns_flex .btns_right .btns1 img {
        width: 14px;
        height: 14px;
        margin-right: 3px;
    }
    .comments_list.no-trans .comments_list_box .list_box .list_item .pages_box {
        min-height: 0;
        height: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .comments_list.no-trans .comments_list_box .list_box .list_item .pages_box .btns {
        width: 40px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_top {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        padding: 16px 16px;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_top .titles {
        font-size: 24px;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_top .text1 {
        padding-top: 14px;
        font-size: 14px;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_top .nums {
        padding-top: 16px;
        font-size: 24px;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_top .text2 {
        font-size: 14px;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_top .btns_box {
        padding-top: 16px;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_top .btns_box .btns {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_bom {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        margin-top: 16px;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_bom .banner_title {
        top: 16px;
        left: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 18px;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_bom .change_box {
        top: 16px;
        right: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_bom .change_box .change_item {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-left: 6px;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box {
        padding-top: 16px;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box {
        width: 160px;
        height: 160px;
        margin: auto;
        border-radius: 50%;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .borders1 {
        width: 160px;
        height: 160px;
        border-radius: 50%;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .borders2 {
        width: 132px;
        height: 132px;
        border-radius: 50%;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .borders2 img {
        width: 132px;
        height: 132px;
        border-radius: 50%;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .tage_box {
        bottom: -4px;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .tage_box .tages {
        width: 104px;
        height: 32px;
        border-radius: 8px 8px 8px 8px;
        font-size: 14px;
        line-height: 32px;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .ls_name {
        padding-top: 16px;
        font-size: 24px;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .ls_texts {
        padding-top: 14px;
        font-size: 14px;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .btns_flex {
        padding-top: 16px;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .btns_flex .btns {
        width: 180px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .comments_list.no-trans .comments_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .btns_flex .btns img {
        width: 14px;
        height: 14px;
        margin-right: 10px;
    }
}

@media (max-width: 1024px) {
    .comments_list.no-trans .comments_list_box .check_box { .mobile-filters(); }
}
@media (max-width: 1024px) {
    .comments_list.no-trans {
        background: #fff;
        .comments_list_box {
            padding: 0 16px;
            .top_box { padding: 14px 0; font-size: 13px; gap: 6px; }
            .check_box {
                .check_felx { padding: 8px 0; gap: 0 8px; }
                .check_felx .check_title { font-size: 13px; line-height: 22px; }
                .check_felx .check_list .check_item { padding: 10px; }
            }
            .list_box {
                display: block; margin-top: 20px; padding: 0;
                .list_item {
                    width: 100%; padding: 0;
                    .item {
                        width: 100%; height: auto; margin: 0; padding: 20px 0;
                        border: 0; border-bottom: 1px solid #edf0f5; border-radius: 0; background: #fff;
                        .title_flex {
                            display: flex; flex-wrap: nowrap; align-items: flex-start; gap: 10px;
                            .titles { flex: 1; min-width: 0; width: auto; font-size: 17px; line-height: 27px; font-weight: 600; color: #303846; overflow-wrap: anywhere; white-space: normal; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; cursor: pointer; }
                            .titles:focus-visible { outline: 2px solid #377cfd; }
                            .teges { flex: 0 0 auto; width: auto; margin: 3px 0 0; }
                            .teges img { width: auto; height: 22px; object-fit: contain; }
                        }
                        .jianjie {
                            padding: 0; margin-top: 10px; font-size: 14px; line-height: 25px; color: #748092;
                            overflow-wrap: anywhere; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 3; overflow: hidden;
                            span { font-size: 14px; color: #377cfd; }
                        }
                        .btns_flex {
                            display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center;
                            gap: 8px; margin-top: 14px; padding: 0;
                            .btns_left { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; }
                            .btns_left .btns1, .btns_left .btns3 { width: auto; min-height: 44px; height: auto; margin: 0; padding: 0; background: transparent; border: 0; font-size: 13px; line-height: 22px; color: #87909d; }
                            .btns_left .btns1 img, .btns_left .btns3 img { width: 14px; height: 14px; margin-right: 4px; object-fit: contain; }
                            .btns_left .btns2 { display: none; }
                            .btns_right .btns1 { width: auto; min-width: 88px; min-height: 44px; height: auto; padding: 0 10px; font-size: 13px; line-height: 22px; border: 1px solid #dbe5f3; border-radius: 4px; color: #377cfd; background: #f5f8fd; }
                        }
                    }
                    .pages_box { padding: 20px 0; }
                    .pages_box > .btns { display: none; }
                    .list_empty { padding: 32px 0; text-align: center; font-size: 14px; color: #87909d; }
                }
                .list_nuw {
                    width: 100%; padding: 0; margin: 24px 0 0;
                    /deep/ .rights_box.no-trans {
                        width: 100%;
                        .r_top { width: 100%; height: auto; padding: 16px; background: #eaf1ff; }
                        .r_top .titles { font-size: 18px; line-height: 28px; }
                        .r_top .text1 { padding-top: 6px; font-size: 13px; line-height: 22px; }
                        .r_top .nums, .r_top .text2 { display: none; }
                        .r_top .btns_box { padding-top: 12px; }
                        .r_top .btns_box .btns { width: 100%; min-height: 44px; padding: 10px; font-size: 14px; line-height: 24px; }
                        .r_bom {
                            width: 100%; height: 300px; margin-top: 16px;
                            .el-carousel, .el-carousel__container { height: 300px; }
                            .el-carousel .el-carousel__container .banner_box {
                                padding-top: 48px;
                                .borders_box { width: 88px; height: 88px; }
                                .borders_box .borders1 { display: none; }
                                .borders_box .borders2, .borders_box .borders2 img { width: 88px; height: 88px; }
                                .ls_name { padding-top: 12px; font-size: 18px; line-height: 28px; }
                                .ls_texts { padding-top: 6px; font-size: 13px; line-height: 22px; }
                                .btns_flex { padding-top: 12px; }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
